/*
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   This enum is used for the pagination & dashboard setting for corresponding modules.
   Developer: Mohammad Saquib Khan, Created Date: 31-March-2024
</summary>
*/
enum userSettingEnum {
  UserLimitConfig = 'userLimitConfig',
  OrderTableColumn = 'OrderTableColumn', //hide/show columns in order table
  HKRTableColumn = 'HKRTableColumn', //hide/show columns in hkr dashboard
  ActiveTrayColumnOrder = 'ColumnOrder', //reorder processes in active tray
  DimensionColumnOrder = 'DimensionColumnOrder', //dimension reorder
  OperatorTaskOrder = 'OperatorTaskOrder', //operator process reorder
  PartsSearch = 'PartSearchSettingKey', // for parts search
  HiddenProcessList = 'HideProcessId', //for order table and operator process
  HideProcessInActiveTray = 'HideActiveProcessId', // for active tray
}

export default userSettingEnum;
